import { useEffect, useRef } from "react";

export const useFormDraft = ({
  draftKey,
  formData,
  setFormData,
  enabled = true,
  debounceMs = 400,
}) => {
  const hydratedRef = useRef(false);

  useEffect(() => {
    if (!enabled || !draftKey) {
      hydratedRef.current = true;
      return;
    }

    try {
      const rawDraft = localStorage.getItem(draftKey);
      if (rawDraft) {
        const parsedDraft = JSON.parse(rawDraft);
        setFormData((prev) => ({ ...prev, ...parsedDraft }));
      }
    } catch (error) {
      console.error("Error restoring draft:", error);
    } finally {
      hydratedRef.current = true;
    }
  }, [draftKey, enabled, setFormData]);

  useEffect(() => {
    if (!enabled || !draftKey || !hydratedRef.current) return undefined;

    const timeoutId = window.setTimeout(() => {
      try {
        localStorage.setItem(draftKey, JSON.stringify(formData));
      } catch (error) {
        console.error("Error saving draft:", error);
      }
    }, debounceMs);

    return () => window.clearTimeout(timeoutId);
  }, [draftKey, enabled, formData, debounceMs]);

  const clearDraft = () => {
    if (!draftKey) return;
    localStorage.removeItem(draftKey);
  };

  return { clearDraft };
};
